import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState
} from 'react';

type CampaignState = {
  textColor: string;
  backgroundColor: string;
  points: number;
  production: number;
  groupColor: string;
  platoon: string;
  totalCost: number;
  growing: number;
  colorTotalCost: string;
};

type CampaignProviderProps = {
  children: ReactNode;
};

const CampaignContext = createContext<{
  state: CampaignState;
  setState: Dispatch<SetStateAction<CampaignState>>;
} | null>(null);

export const CampaignProvider = ({ children }: CampaignProviderProps) => {
  const [state, setState] = useState<CampaignState>({
    textColor: '',
    backgroundColor: '',
    points: 0,
    production: 0,
    groupColor: '',
    platoon: '',
    totalCost: 0,
    growing: 0,
    colorTotalCost: ''
  });

  return (
    <CampaignContext.Provider value={{ state, setState }}>
      {children}
    </CampaignContext.Provider>
  );
};

export const useCampaignContext = () => {
  return useContext(CampaignContext);
};
